import {
  CoreQuery,
  SubmitF2fOrderIssueBody,
  SubmitOnlineOrderIssueBody,
} from "@gen/app-query";
import { useQueryClient } from "@tanstack/react-query";

interface UseSubmitOrderIssueMutationProps {
  transactionId: number;
  isF2f: boolean;
  successMessage?: string;
}

export function useSubmitOrderIssueMutation({
  transactionId,
  isF2f,
  successMessage,
}: UseSubmitOrderIssueMutationProps) {
  const queryClient = useQueryClient();

  const { mutate: submitF2fOrderIssue, isPending: isF2fOrderIssueSubmitting } =
    CoreQuery.useAdmin_submitF2fOrderIssueMutationWithParameters({
      meta: {
        success: successMessage,
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: CoreQuery.admin_getF2fTransactionQueryKey(transactionId),
        });
      },
    });

  const {
    mutate: submitOnlineOrderIssue,
    isPending: isOnlineOrderIssueSubmitting,
  } = CoreQuery.useAdmin_submitOnlineOrderIssueMutationWithParameters({
    meta: {
      success: successMessage,
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CoreQuery.admin_getOnlineTransactionQueryKey(transactionId),
      });
    },
  });

  const submitOrderIssue = (description: string) => {
    if (isF2f) {
      submitF2fOrderIssue({
        transaction_id: transactionId,
        submitF2fOrderIssueBody: SubmitF2fOrderIssueBody.fromJS({
          description: description.trim(),
        }),
      });
    } else {
      submitOnlineOrderIssue({
        transaction_id: transactionId,
        submitOnlineOrderIssueBody: SubmitOnlineOrderIssueBody.fromJS({
          description: description.trim(),
        }),
      });
    }
  };

  return {
    submitOrderIssue,
    isLoading: isF2f ? isF2fOrderIssueSubmitting : isOnlineOrderIssueSubmitting,
  };
}
